import { Box, SxProps, Theme } from '@mui/material'
import { ReactNode } from 'react'
import { COLORS } from 'styles/colors'
import { TypographyHeaderSecondary } from 'ui/typography/TypographyHeaderSecondary'

type ButtonProps = {
	onClick: () => void
	title: string
	endAdornment?: ReactNode
	startAdornment?: ReactNode
	backgroundColor?: string
	sx?: SxProps<Theme>
	disabled?: boolean
}

const LargeCardButton = ({
	onClick,
	title,
	endAdornment,
	startAdornment,
	backgroundColor = '#fff',
	sx = {},
	disabled = false,
}: ButtonProps) => {
	return (
		<Box
			component={'button'}
			disabled={disabled}
			display='flex'
			flexDirection='row'
			justifyContent='space-between'
			alignItems={'center'}
			onClick={disabled ? undefined : onClick}
			sx={{
				p: '0px 44px',
				width: '100%',
				boxShadow: 'none',
				borderRadius: '8px',
				backgroundColor: backgroundColor,
				cursor: 'pointer',
				border: `1px solid ${COLORS.icon}`,
				height: '56px',
				opacity: disabled ? 0.5 : 1,
				pointerEvents: disabled ? 'none' : 'auto',
				'&:active': {
					opacity: 0.7,
				},
				'&:touch': {
					opacity: 0.7,
				},
				...sx,
			}}
		>
			{startAdornment ? startAdornment : <span></span>}
			<TypographyHeaderSecondary sx={{ color: COLORS.icon, fontWeight: 600 }}>
				{title}
			</TypographyHeaderSecondary>
			{endAdornment ? endAdornment : <span></span>}
		</Box>
	)
}

export default LargeCardButton
